<template>
  <v-dialog
    id="quiz-component"
    content-class="fdi-quiz-modal"
    class="border-radius-15"
    persistent
    max-width="280"
    v-model="answerDialog"
  >
    <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
      <v-container pa-0 text-xs-center>
        <v-card-text class="question-text-container">
          <p
            class="text-xs-center white--text fs-24 mt-3"
          >{{step.inputQuestion.toUpperCase() + "?"}}</p>

          <div class="white pa-3 border-radius-5">
            <v-text-field
              color="grey darken-2"
              @keyup.enter.stop.prevent="checkAnswer"
              :counter="!isFinalInput ? inputLength : 'NA'"
              :messages="!isFinalInput ? messageHint : ''"
              v-model="userInput"
              label="Input Answer Here"
            ></v-text-field>
          </div>
        </v-card-text>
      </v-container>
      <v-card-actions class="modal-actions">
        <v-btn flat @click.native="goBack">
          <v-img :src="backButton"/>
        </v-btn>

        <v-spacer></v-spacer>
        <v-btn class="button-border" block flat large color="white" @click="checkAnswer">submit</v-btn>
        <v-spacer></v-spacer>
        <v-btn flat @click.native="getHelp">
          <v-img :src="hintButton"/>
        </v-btn>
      </v-card-actions>
    </v-card>

    <v-dialog
      content-class="fdi-quiz-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="incorrectDialog"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container pa-0 text-xs-center>
          <v-card-text>
            <p class="text-xs-center white--text fs-24 mt-3 mb-0">Not Quite,</p>
            <p class="text-xs-center white--text fs-24">try again detective</p>
          </v-card-text>
          <v-card-text>
            <p class="text-xs-center">
              <v-avatar size="125">
                <v-img :src="wrongIcon" height="100%"/>
              </v-avatar>
            </p>
          </v-card-text>
        </v-container>
        <v-card-actions class="modal-actions">
          <v-btn flat disabled/>
          <v-spacer></v-spacer>
          <v-btn class="button-border" block flat large color="white" @click="tryAgain">Try Again</v-btn>
          <v-spacer></v-spacer>
          <v-btn flat @click.native="getHelp">
            <v-img :src="hintButton" height="100%"/>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="fdi-quiz-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="correctDialog"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container pa-0 text-xs-center>
          <v-card-text>
            <p class="text-xs-center white--text fs-24 mt-3 mb-0">Correct,</p>
            <p class="text-xs-center white--text fs-24">Good job detective</p>
          </v-card-text>
          <v-card-text>
            <p class="text-xs-center">
              <v-avatar size="125">
                <v-img :src="rightIcon" height="100%"/>
              </v-avatar>
            </p>
          </v-card-text>
        </v-container>
      </v-card>
    </v-dialog>

    <v-dialog
      id="help-dialog"
      content-class="fdi-quiz-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="helpDialog"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container class="text-xs-center pa-0">
          <v-card-text>
            <p class="text-xs-center white--text fs-24 mt-3 mb-0">Need some help?</p>
          </v-card-text>

          <v-layout class="mt-2" column align-center>
            <v-flex id="hint-container" mt-2 v-if="hints.length > 0">
              <v-btn
                v-for="(hint, i) in hints"
                :key="`hint-${i+1}`"
                flat
                block
                large
                color="white"
                class="mt-2 button-border"
                @click="() => openHint(i)"
              >Hint #{{i+1}}</v-btn>
            </v-flex>
            <v-flex id="hint-container" mt-2 v-else>
              <p class="text-xs-center white--text fs-36 mb-0">?</p>
              <p
                class="text-xs-center white--text fs-18 mb-0"
              >No hints available, click giveup if you are stuck</p>
            </v-flex>
          </v-layout>
        </v-container>
        <v-card-actions class="modal-actions">
          <v-btn flat @click.native="closeHintToQuestion">
            <v-img :src="backButton" height="100%"/>
          </v-btn>

          <v-spacer></v-spacer>
          <v-btn
            class="button-border"
            key="`hint-answer`"
            flat
            block
            large
            color="white"
            @click="giveUp"
          >Give Up</v-btn>
          <v-spacer></v-spacer>

          <v-btn flat></v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog
      content-class="hint-dialog"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="hintDialog"
    >
      <v-container>
        <!-- <v-container mb-3 text-xs-center class="black white--text" pa-2>
        <p v-if="openClueType === 1" class="fs-24 bebas">{{hints[openHintIndex].message}}</p>
        <v-flex xs12 d-flex align-center justify-center>
          <v-img v-if="openClueType === 2" :src="hints[openHintIndex].image.url" contain />
        </v-flex>
        </v-container>-->
        <v-card flat style="background-color: Transparent">
          <v-container text-xs-center>
            <p
              v-if="openClueType === 1"
              class="fs-24 black--text bebas"
            >{{hints[openHintIndex].message}}</p>
          </v-container>
          <v-layout row>
            <v-flex d-flex class="black">
              <v-img
                class="ma-2"
                v-if="openClueType === 2"
                :src="hints[openHintIndex].image.url"
                contain
              />
            </v-flex>
          </v-layout>
        </v-card>
        <v-layout row>
          <v-flex d-flex xs-3>
            <v-btn flat @click.native="closeHintToHelp">
              <v-img :src="backButtonBlk"/>
            </v-btn>
            <v-spacer></v-spacer>
            <v-btn
              class="button-border-2"
              key="`hint-answer`"
              block
              large
              flat
              color="black"
              @click="closeHintToQuestion"
            >Try Again</v-btn>
          </v-flex>
        </v-layout>
      </v-container>
    </v-dialog>
    <v-dialog
      content-class="fdi-quiz-modal"
      class="border-radius-15"
      persistent
      max-width="280"
      v-model="giveUpDialog"
    >
      <v-card color="rgba(0, 0, 0, 0.9)" class="border-radius-15 modal-class">
        <v-container pa-0>
          <v-card-text>
            <p class="fs-36 text-xs-center white--text mt-3">You dirty rat!</p>
          </v-card-text>
          <v-card-text class="bebas">
            <p class="fs-24 text-xs-center white--text">The correct answer is</p>
            <v-container pa-0 d-flex justify-center>
              <div v-for="i in step.inputAnswer.length" :key="i">
                <div class="answer-text-letter">
                  <p class="text-xs-center white--text fs-16">{{step.inputAnswer[i-1]}}</p>
                </div>
              </div>
            </v-container>
          </v-card-text>
        </v-container>
        <v-card-actions class="modal-actions">
          <v-btn flat @click.native="closeHintToQuestion">
            <v-img :src="backButton"/>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-dialog>
</template>

<script>
import Store from "@/store";
import modalBackground from "../../assets/backgrounds/modal-blk.png";
import backButton from "../../assets/directions/back_button.png";
import backButtonBlk from "../../assets/directions/back_button-blk.png";
import tryAgainButton from "../../assets/buttons/tryagain.png";
import tryAgainWhiteButton from "../../assets/buttons/tryagain-white.png";
import arrivedButton from "../../assets/directions/arrived_button.png";
import hintButton from "../../assets/directions/hint_button.png";
import submitButton from "../../assets/submit-button.png";
import wrongIcon from "../../assets/wrong/wrong-icon.png";
import rightIcon from "../../assets/right/right-icon.png";

export default {
  name: "quiz-component",
  props: {
    step: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      tourContainerHeight: this.$store.getters.appInnerHeight - 85,
      answerDialog: true,
      incorrectDialog: false,
      correctDialog: false,
      helpDialog: false,
      hintDialog: false,
      giveUpDialog: false,
      openHintIndex: 0,
      userInput: "",
      hints: this.step.hints ? this.step.hints : [],
      modalBackground: modalBackground,
      backButton: backButton,
      backButtonBlk: backButtonBlk,
      arrivedButton: arrivedButton,
      submitButton: submitButton,
      hintButton: hintButton,
      tryAgainButton: tryAgainButton,
      tryAgainWhiteButton: tryAgainWhiteButton,
      wrongIcon: wrongIcon,
      rightIcon: rightIcon
    };
  },
  methods: {
    closeAllDialogs() {
      this.answerDialog = false;
      this.incorrectDialog = false;
      this.correctDialog = false;
      this.helpDialog = false;
      this.hintDialog = false;
      this.giveUpDialog = false;
    },
    openHint(index) {
      this.closeAllDialogs();
      this.openHintIndex = index;
      this.hintDialog = true;
    },
    closeHintToHelp() {
      this.closeAllDialogs();
      this.helpDialog = true;
      this.openHintIndex = 0;
    },
    closeHintToQuestion() {
      this.closeAllDialogs();
      this.answerDialog = true;
      this.openHintIndex = 0;
    },
    goBack() {
      this.closeAllDialogs();
      this.$store.dispatch("decrementStep");
    },
    goForward() {
      this.closeAllDialogs();
      this.$store.dispatch("incrementStep");
    },
    tryAgain() {
      this.closeAllDialogs();
      this.answerDialog = true;
    },
    getHelp() {
      this.closeAllDialogs();
      this.helpDialog = true;
    },
    giveUp() {
      this.closeAllDialogs();
      this.giveUpDialog = true;
    },
    checkAnswer() {
      if (
        this.userInput.toLowerCase().trim() ===
        this.step.inputAnswer.toLowerCase()
      ) {
        this.userInput = "";
        this.answerDialog = false;
        this.correctDialog = true;
        setTimeout(() => {
          this.goForward();
        }, 1500);
      } else {
        this.userInput = "";
        this.answerDialog = false;
        this.incorrectDialog = true;
      }
    }
  },
  computed: {
    imageClass() {
      return {
        "max-height": this.tourContainerHeight + "px",
        width: "auto"
      };
    },
    openClueType() {
      return this.hints.length !== 0
        ? this.hints[this.openHintIndex].hintType
        : null;
    },
    messageHint() {
      return `The answer is ${this.inputLength} Letters long`.toUpperCase();
    },
    contentHeight() {
      return window.innerHeight - 500;
    },
    inputQuestion() {
      return this.step.inputQuestion;
    },
    inputLength() {
      return this.step.inputAnswer.length || 0;
    },
    hintText() {
      return `HINT: The answer is ${this.inputLength} letters`;
    },
    isFinalInput() {
      return this.step.finalInput;
    }
  }
};
</script>

<style>
.hint-dialog.v-dialog {
  -webkit-box-shadow: 0;
  box-shadow: none;
}

#hint-dialog .hint-text {
  font-size: 24px;
}

.bg-trans {
  opacity: 85%;
}

.answer-text-letter {
  border-bottom: 0.5px solid white;
  width: 85%;
  margin: auto auto;
}

.answer-text-letter p {
  font-size: 18px;
  margin-top: 30%;
}

.bg-overlay {
  height: 100%;
  position: absolute;
  top: 0;
  opacity: 0.85;
  background-color: white;
}

.border-button .v-btn.v-btn--outline {
  border: 4px solid black;
  font-size: 24px;
}

.border-button {
  letter-spacing: 1.1px;
  font-size: 20px;
  width: 100%;
}

.question-text {
  font-family: "BebasNeue-Regular";
  font-size: 27px;
  letter-spacing: 2px;
  line-height: 44px;
  width: 100%;
}

#hint-container {
  width: 40%;
}

.question-text-container {
  height: 150px;
}

.v-messages {
}

.trans-background {
}

.modal-class .v-text-field__slot .v-label {
  font-family: "PrestigeElite-STD";
  left: auto;
  right: auto;
}

.modal-class .v-text-field__details {
  font-family: "BebasNeue-Regular";
}

.modal-class .v-text-field__details .v-messages__message {
  font-size: 14px;
  color: red;
  letter-spacing: 1.1px;
  margin-left: auto;
  margin-right: auto;
}

.modal-class .v-text-field__details .v-counter {
  font-size: 14px;
  color: red;
  letter-spacing: 1.1px;
  margin-left: auto;
  margin-right: auto;
}

.v-overlay--active::before {
  background-color: white;
  opacity: 0.85;
}
</style>
